import React, { useCallback, useEffect, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { useLiveChatConfig } from "../NavProvider";
import LiveChatButton from "./LiveChatButton";
var useStyles = makeStyles(function (theme) {
    return createStyles({
        liveChat: {
            position: "fixed",
            bottom: 16,
            right: 16,
            zIndex: theme.zIndex.appBar + 50,
            transition: "ease-in-out bottom 200ms",
        },
    });
});
var LiveChat = function (_a) {
    var path = _a.path;
    var styles = useStyles();
    var config = useLiveChatConfig();
    var _b = useState(""), whatsAppUrl = _b[0], setWhatsAppUrl = _b[1];
    var _c = useState(0), bottomOffset = _c[0], setBottomOffset = _c[1];
    var configureWhatsAppUrl = useCallback(function (config) {
        var _a;
        var urlsToEnableLiveChat = config.urlsToEnableLiveChat, defaultShortCode = config.defaultShortCode, whatsAppLink = config.whatsAppLink;
        if (urlsToEnableLiveChat.length) {
            var matchedUrl = urlsToEnableLiveChat.find(function (item) { return RegExp(item.url).test(window.location.href); });
            var shortCode = (_a = matchedUrl === null || matchedUrl === void 0 ? void 0 : matchedUrl.shortCode) !== null && _a !== void 0 ? _a : defaultShortCode;
            if (matchedUrl && shortCode)
                setWhatsAppUrl(whatsAppLink + encodeURIComponent(shortCode));
            else
                setWhatsAppUrl("");
        }
    }, []);
    useEffect(function () {
        var observer = new MutationObserver(function () {
            var stickyElement = document.querySelector("[data-livechat-sticky]");
            if (stickyElement)
                setBottomOffset(stickyElement.offsetHeight);
            else
                setBottomOffset(0);
        });
        observer.observe(document.body, { subtree: true, childList: true });
        return function () {
            observer.disconnect();
        };
    }, []);
    useEffect(function () {
        var popStateListener = function () {
            configureWhatsAppUrl(config);
        };
        window.addEventListener("popstate", popStateListener);
        return function () {
            window.removeEventListener("popstate", popStateListener);
        };
    }, [config, configureWhatsAppUrl]);
    useEffect(function () {
        configureWhatsAppUrl(config);
    }, [path, config, configureWhatsAppUrl]);
    if (!whatsAppUrl)
        return null;
    return (React.createElement("div", { id: "acm-livechat", className: styles.liveChat, style: { bottom: (bottomOffset !== null && bottomOffset !== void 0 ? bottomOffset : 0) + 16 } },
        React.createElement(LiveChatButton, { whatsAppUrl: whatsAppUrl })));
};
export default LiveChat;
